import React from "react";
import BoxContainer from "components/BoxContainer";
import Text from "components/Text";
import Button from "components/Button";
import imageResolver from "utils/image-resolver";
import { Link } from "gatsby";
import starSvg from "assets/translation-services/star.svg";

function Reviews({ data }) {
  const ratingStars = (rating) => {
    const stars = [];
    for (let i = 0; i < Number(rating); i++) {
      stars.push(<img src={starSvg} alt="rating" />);
    }
    return stars;
  };

  const runCallback = (cb) => {
    return cb();
  };

  return (
    <>
      {/* old rating component */}
      {data.achievedstars || data.Ratinghead ? (
        <BoxContainer className="py-[32px]" background="bg-gradient1">
          <div className="pt-[80px] pb-8 md:w-10/12 m-auto 2xl:max-w-6xl">
            <div className="md:flex md:gap-16">
              <div className="md:w-1/2 mb-12 md:mb-0">
                <Text
                  as="h2"
                  className="text-yellow font-secondary font-bold text-4xl2 text-center sm:text-left"
                >
                  {data.achievedstars}&nbsp;
                  {data.totalstars}
                </Text>
                <Text
                  as="h2"
                  className="text-midBlue font-secondary font-bold text-4xl2 text-center sm:text-left"
                >
                  {data.Ratinghead}
                </Text>
                <Text
                  as="h2"
                  className="text-midBlue text-xl2 leading-loose font-secondary text-center sm:text-left"
                >
                  {data.ratingsummary}
                </Text>
                <div className="flex flex-row gap-3 justify-center sm:justify-start">
                  {runCallback(() => {
                    const row = [];
                    for (var i = 0; i < data.achievedstarsfigure; i++) {
                      row.push(
                        <svg
                          key={i}
                          width="60px"
                          height="60px"
                          className="w-[40px]"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 48 48"
                          enableBackground="new 0 0 48 48"
                        >
                          <polygon
                            fill="#FFCA28"
                            points="24,4 31,17 45,19 35,29 37,44 24,37 11,44 13,29 3,19 17,17 "
                          />
                          <g>
                            <polygon
                              fill="#F9A825"
                              points="24,25 31,17 24,4 &#9;"
                            />
                            <polygon
                              fill="#F9A825"
                              points="45,19 24,25 35,29 &#9;"
                            />
                            <polygon
                              fill="#F9A825"
                              points="37,44 24,25 24,37 &#9;"
                            />
                            <polygon
                              fill="#F9A825"
                              points="13,29 11,44 24,25 &#9;"
                            />
                            <polygon
                              fill="#F9A825"
                              points="3,19 24,25 17,17 &#9;"
                            />
                          </g>
                        </svg>
                      );
                    }
                    return row;
                  })}
                </div>
                <Text
                  as="div"
                  className="text-midBlue font-opensans text-lg leading-8 text-center sm:text-left"
                  highlightedText={data.ratingcontent.highlightWords}
                  highlightedColor={data.ratingcontent.highlightedColor}
                >
                  {data.ratingcontent.description}
                </Text>
                <Button
                  title={data.cta.text}
                  href={data.cta.href}
                  className="w-56 h-14 text-lg text-center text-white font-opensans font-medium bg-yellow hover:bg-newOrange-100 transition-colors rounded-full cursor-pointer flex items-center justify-center mt-7 mx-auto sm:mx-0"
                />
              </div>
              <div className="md:w-1/2 mt-4 md:mt-0">
                <Text
                  as="p"
                  className="text-midBlue font-secondary text-lg font-medium mb-5 text-center sm:text-left"
                >
                  {data.testimonialhead}
                </Text>
                {data.testimonialdata.map((item, i) => (
                  <div
                    key={i}
                    className="bg-white rounded-[14px] p-6 mb-5 shadow-reviewCard"
                  >
                    <a href={item.href}>
                      <Text
                        as="h3"
                        className="text-darkBlue font-opensans text-lg font-bold"
                      >
                        "{item.content}"
                      </Text>
                      <div className="flex items-center mt-6">
                        <div>
                          <Text
                            as="p"
                            className="text-lightBluegray font-opensans text-lg font-semibold"
                          >
                            {item.name}
                          </Text>
                        </div>
                        <div className="ml-auto">
                          {imageResolver(item.title, item.icon, item.className)}
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </BoxContainer>
      ) : null}
      {/* new rating component */}
      {data.rating_title || data.rating_description ? (
        <div className="py-28 px-6">
          <div className="w-full max-w-6xl mx-auto">
            <Text
              as="h2"
              highlightedText={data?.rating_highlighted_word || []}
              highlightedColor={data?.rating_highlighted_color || ""}
              className="text-3xl leading-[55px] review_title text-center xs:font-secondary font-semibold pb-2"
            >
              {data.rating_title}
            </Text>
            <Text
              as="h3"
              className="text-5xl leading-[60px] text-center xs:font-secondary font-bold pb-7"
            >
              {data.rating_subtitle}
            </Text>
            <Text
              as="div"
              className="text-lg leading-8 text-[#3D3F42] text-center font-opensans pb-11 max-w-5xl mx-auto"
            >
              {data.rating_description}
            </Text>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 py-14">
              {data.reviews &&
                data.reviews.map((review, i) => {
                  return (
                    <div
                      className="border-2 rounded-xl border-black w-full px-6 py-10 flex flex-col gap-y-8"
                      key={i}
                    >
                      <div className="flex justify-between">
                        <div className="flex justify-center gap-[6px] pb-7">
                          {ratingStars(review.star_rating)}
                        </div>
                        {review.company_logo ? (
                          <img
                            src={review.company_logo}
                            alt="company_logo"
                            className="w-24 h-6"
                          />
                        ) : null}
                      </div>
                      <div className="text-center font-primary">
                        <Text
                          as="p"
                          className="font-bold text-black min-h-[56px]"
                        >
                          {review.review_text}
                        </Text>
                        <Text as="p" className="text-sm text-grayBorder">
                          {review.review_description}
                        </Text>
                      </div>
                      <div className="text-center font-primary">
                        <Text as="p" className="font-bold text-black">
                          {review.reviewer_name}
                        </Text>
                        <Text as="p" className="text-sm text-grayBorder">
                          {review.reviewer_designation}
                        </Text>
                      </div>
                    </div>
                  );
                })}
            </div>
            {data.rating_button_text && (
              <div className="flex items-center justify-center">
                <Link
                  to={data.rating_button_link}
                  className="text-24 review_title text-center xs:font-secondary font-medium inline-flex justify-center items-center space-x-3"
                >
                  <p>{data.rating_button_text}</p>
                  <p>&#x2192;</p>
                </Link>
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}
export default Reviews;
